import { useQuery } from "@tanstack/react-query";
import { LuFilePieChart } from "react-icons/lu";
import { Link } from "react-router-dom";
import { handleFetchRequestsCount } from "../../api/requests";

export default function ManageProgress() {
  const { data: count } = useQuery({
    queryKey: ["progressCount"],
    queryFn:() => handleFetchRequestsCount({ status: 'in-approval' }),
  });
  return (
    <Link
      to={`/requests/status/in-approval`}
      className={`col-span-6 sm:col-span-4 lg:col-span-2 bg-yellow-100 p-4 border border-yellow-200`}

    >
      <div className="flex justify-between">
        <div className="flex flex-col justify-center items-center">
          <div className="flex items-center">
            <LuFilePieChart color="#323232" size={24} />
          <div className="mx-2">In-Approval Requests</div>
          </div>
        </div>
        <div className="font-bold">{count}</div>
      </div>
    </Link>
  );
}
